import { registerPlugin } from '@playkit-js/kaltura-player-js';
import { pluginName, TaxonomyTranscript } from './plugin-taxonomy-transcript';

/* @ts-expect-error there are multiple type declarations for `BasePlugin` which conflict with each other... */
registerPlugin(pluginName, TaxonomyTranscript);

export * from './types';
